import React from 'react';
import {Link, Control, Slider} from 'MWC';
import '../less';
import CustomDropdown from '../../../auxiliary-components/shared/CustomDropdown';
import FilesForDownload from "../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import banner_img from "../img/banner_img.png";
import banner_img_mob from "../img/banner_img_mob.png";
import fgv_logo from "../img/fgv_logo.png";
import Banner from "../../../auxiliary-components/shared/Banner";
import hint_data from "../enums/hint_data.json";
import Hint from "../../../auxiliary-components/shared/Hint";
import { Preloader } from 'MWComponents';
import SliderComponent from '../../../auxiliary-components/shared/Slider';
import DOMPurify from 'utils/sanitize';

export default function template() {
    const isMobile = this.isViewportMobile(),

      videoLinksSlider = [
        {
          src: "https://www.youtube.com/embed/cENYzGufiS8",
          title: "FGV_VIDEO_ITEM_TITLE_1",
          text: "FGV_VIDEO_ITEM_TEXT_1"
        },
        {
          src: "https://www.youtube.com/embed/Z0va55Nki0k",
          title: "FGV_VIDEO_ITEM_TITLE_2",
          text: "FGV_VIDEO_ITEM_TEXT_2"
        },
        {
          src: "https://www.youtube.com/embed/G_Snb1f9AcA",
          title: "FGV_VIDEO_ITEM_TITLE_3",
          text: "FGV_VIDEO_ITEM_TEXT_3"
        },
        {
          src: "https://www.youtube.com/embed/4Lv1aPlAZps",
          title: "FGV_VIDEO_ITEM_TITLE_4",
          text: "FGV_VIDEO_ITEM_TEXT_4"
        },
        {
          src: "https://www.youtube.com/embed/yzwRIYe78GI",
          title: "FGV_VIDEO_ITEM_TITLE_5",
          text: "FGV_VIDEO_ITEM_TEXT_5"
        }
      ],
      videoLinksSliderMobile = videoLinksSlider.slice(1),

        videoLinks = [
            '/static/fgvo/videos/1.mp4',
            '/static/fgvo/videos/2.mp4',
            '/static/fgvo/videos/3.mp4',
            '/static/fgvo/videos/4.mp4',
            '/static/fgvo/videos/5.mp4',
            '/static/fgvo/videos/6.mp4',
        ],
        dropdownContent = (
            <div className="video-grid">
                {videoLinks.map((video, index) => {
                    return (
                        <div className="grid-item" key={index}>
                            <video width={isMobile ? '328' : '384'} height={isMobile ? '181' : '208'} controls play="no" frameBorder="0" style={{borderRadius:24}}>
                                <source src={video} type="video/mp4" />
                            </video>
                        </div>
                    );
                })}
            </div>
        ),
      videoBlock = isMobile ? (
        <div className='video-block mobile'>
          <div className="video-wrap">
            <iframe
              width = {'328'}
              height = {'181'}
              src = {'https://www.youtube.com/embed/cENYzGufiS8'}
              frameBorder = {'0'}
              allow = {'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
              allowFullScreen = {'allowFullScreen'}
            ></iframe>
          </div>
          <div className={`left-side-item selected`}>
            <div className='left-side-item-title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGV_VIDEO_ITEM_TITLE_1'))}}></div>
            <div className='left-side-item-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGV_VIDEO_ITEM_TEXT_1'))}}></div>
          </div>
          <CustomDropdown title={this.l10n('FGV_VIDEO_DROPDOWN_TEXT')} classNameItems={'fgvo'}>
            {videoLinksSliderMobile.map((item, index) => {
              return (
                <div>
                  <div className="video-wrap">
                    <iframe
                      width = {'328'}
                      height = {'181'}
                      src = {item.src}
                      frameBorder = {'0'}
                      allow = {'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
                      allowFullScreen = {'allowFullScreen'}
                    ></iframe>
                  </div>
                  <div className={`left-side-item selected`} key={index}>
                    <div className='left-side-item-title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></div>
                    <div className='left-side-item-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                  </div>
                </div>

              );
            })}
          </CustomDropdown>
        </div>
      ) :
        (
         <div className='video-block'>
           <div className='left-side'>
             {videoLinksSlider.map((item, index) => {
               const isSelected = this.state.videoLink === item.src ? 'selected' : '';
               return (
                 <div className={`left-side-item ${isSelected}`} onClick={() => this.changeVideo(item.src)} key={index}>
                   <div className='left-side-item-title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></div>
                   <div className='left-side-item-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                 </div>
               );
             })}
           </div>
           <div className='right-side'>
             <div className="video-wrap">
               <iframe
                 width = {'680'}
                 height = {'376'}
                 src = {this.state.videoLink}
                 frameBorder = {'0'}
                 allow = {'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
                 allowFullScreen = {'allowFullScreen'}
               ></iframe>
             </div>
           </div>
         </div>
        )

    return (
        <div className="module-fgvo">
            <div className='slider-container'>
              {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
            </div>
            <div className="content">
                <Hint isMobile={isMobile} data={hint_data}/>
              {videoBlock}

                {/*<div className="fgvo-video">*/}
                {/*    <div className="slide-wrap">*/}
                {/*        <Slider*/}
                {/*        showNavigation={true}*/}
                {/*        showArrows={true}*/}
                {/*        >*/}
                {/*            {videoLinksSlider.map((video, index) => {*/}
                {/*                return (*/}
                {/*                    <div className="slide" key={index}>*/}
                {/*                        <div className="slide-content">*/}
                {/*                            <div className="video-wrap">*/}
                {/*                                <iframe*/}
                {/*                                    width = {video.width}*/}
                {/*                                    height = {video.height}*/}
                {/*                                    src = {video.src}*/}
                {/*                                    frameBorder = {video.frameBorder}*/}
                {/*                                    allow = {video.allow}*/}
                {/*                                    allowFullScreen = {video.allowFullScreen}*/}
                {/*                                ></iframe>*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                );*/}
                {/*            })}*/}
                {/*        </Slider>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="fgvo-explanation">
                    <h2 className="explanation-title">{this.l10n('FGVO_WORK')}</h2>
                    <p
                        className="explanation-text"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGVO_WORK_CONTENT_1'))}}
                    />
                    <p
                        className="explanation-text"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGVO_WORK_CONTENT_2'))}}
                    />
                    <p
                        className="explanation-text"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGVO_WORK_CONTENT_3'))}}
                    />
                </div>

                <CustomDropdown title={this.l10n('FGVO_PDF-FILE-6')} classNameItems={'fgvo'} titleTag={"h2"}>
                    {dropdownContent}
                </CustomDropdown>

                <div className='fgvo-explanation'>
                  <h2 className="explanation-title">{this.l10n('FGVO_WORK_CONTENT_7')}</h2>
                  <p
                    className="explanation-text"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FGVO_WORK_CONTENT_8'))}}
                  />
                </div>

              <FilesForDownload page={"white-page"} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
            </div>
        </div>
    );
}
